const pixelToInteger = (pixel: string): number =>
  parseInt(pixel.replace('px', ''));

export default pixelToInteger;
